<template>
  <div class="withdraw">
    <Row class="withdrawTip">
      <Col class="desc" span="14">
        <h3 class="title">
          <i></i>
          <span>{{$t('label.w135')}}</span>
        </h3>
        <div v-html="$t('other.w100')"></div>
      </Col>
      <Col span="10" class="bg">
        <div class="img"></div>
      </Col>
    </Row>
    <div class="sw">
      <AccountSwitch :type.sync="type"/>
    </div>
    <div class="feeaccount">
      <Form label-position="top" ref="form" class="feeform" :model="form" :rules="formRules">
        <FormItem :label="$t('label.w156')">
          <Select v-model="form.bankCardId">
            <Option
              v-for="v in cardlist"
              :key="v.BankCardId"
              :value="v.BankCardId"
            >{{v.BankName}}</Option>
          </Select>
          <router-link :to="{name:'bankCard'}">{{$t('nav.w56')}}</router-link>
        </FormItem>
        <FormItem :label="$t('label.w157')" prop="amount">
          <Input v-model="form.amount"  @on-change="handleChange('amount')" @on-blur="blurChage('amount')" :maxlength="value">
            <span slot="append">{{$t('label.w5')}}</span>
          </Input>
          <span class="all" @click="form.amount=amount.toString()">{{$t('btn.b73')}}</span>
          <span class="withdraw">({{$t('label.w158')}}：¥{{amount | money}})</span>
        </FormItem>
        <FormItem :label="$t('label.w21')" prop="transactionPassword">
          <Input :type="inputtype" @on-change="inputtype='password'" v-model="form.transactionPassword" autocomplete="off"/>
          <router-link :to="{name:'security'}">{{$t('nav.w58')}}</router-link>
        </FormItem>
        <FormItem class="withdrawBtn">
          <Button type="primary" :loading="btnLoading" @click="submit">{{$t('btn.b28')}}</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import AccountSwitch from "./accountSwitch";
import formRule from "@/libs/formRule";
export default {
  components: { AccountSwitch },
  data() {
    return {
      inputtype:'text',
      type: "feeaccount",
      btnLoading:false,
      cardlist: [],
      amount: 0,
      form: {
        amount: "",
        bankCardId: "",
        transactionPassword: ""
      },
      formRules: {
        amount: [
          { required: true, message: this.$t('msg.m52'), trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (/^\d+(\.\d{1,2})?$/.test(value.toString())) {
                callback();
              } else {
                callback(new Error(this.$t('msg.m52')));
              }
            },
            trigger: "submit"
          }
        ],
        transactionPassword: formRule.pwdUse
      },
      value:100
    };
  },
  methods: {
     //金额改变
    handleChange(type) {
      if (type == "amount") {
        if (isNaN(this.form.amount)) return (this.form.amount = "");
        // if (this.form.amount.length > this.amount.toString().length) {
        if (Number(this.form.amount) > Number(this.amount)) {
          this.form.amount = this.amount.toString();
          this.value = this.amount.toString().length;
        }else{
          this.value = 100
        }
      }
    },
     //输入金额失去焦点
    blurChage(type) {
      if (type == "amount") {
        if (this.form.amount  > this.amount) {
          this.form.amount = this.amount.toString();
        }else{
          if(this.form.amount.toString().indexOf('.')>-1){
             this.form.amount = Number(this.form.amount).toFixed(2)
          }else{
             this.form.amount = Number(this.form.amount).toString()
          }
        }
      }
    },
    getdata() {
      this.$axios
        .get("/Member/RZJFund/CanWithdrawalAmount", {
          params: {
            accountType: this.accountType
          }
        })
        .then(res => {
          if (res.err) return;
          this.cardlist = res.BankCardLists;
          this.amount = res.canWithdrawalAmount;
          if (res.BankCardLists && res.BankCardLists.length) {
            this.form.bankCardId = res.BankCardLists[0].BankCardId;
          }
        });
    },
    async submit() {
      console.log(typeof this.form.amount)
      let valid=await this.$refs.form.validate();
      if(!valid) return;
      this.btnLoading= true
      let res=await this.$axios.post('/Member/RZJFund/Withdrawal',{
        accountType:this.accountType,
        ...this.form
      })
      this.btnLoading = false
      if(res.err) return res.throw();
      this.$Message.success(this.$t('msg.m53'))
      this.$router.push({name:'moneyRecord'});
    }
  },
  computed:{
    accountType(){
      switch(this.type){
        case "feeaccount": return  0
        case "management": return 1
        case "award": return 2
      }
      // if()
      // return this.type == "feeaccount" ? 0 : 1
    },
    safe(){
      return this.$store.state.user.safe
    }
  },
  watch: {
    type() {
      this.$refs.form.resetFields();
      this.getdata();
    }
  },
  mounted() {
    if(this.safe.TransactionPassword===false){
      this.$Message.error(this.$t('msg.m54'))
      this.$router.push({name:'security'})
    }else{
      this.getdata();
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw {
    padding-left: 20px;
    background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
    background-size: 90px 74px;
    background-position: 50px 75px;
  .withdrawTip {
    display: flex;
    .title {
      font-weight: 500;
      color: rgba(94, 143, 252, 1);
      font-size: 14px;
      margin: 40px 0 30px 0;
      span {
        margin-left: 5px;
      }
      i {
        display: inline-block;
        background: url("../../assets/assetcenter/public_hint.png") no-repeat;
        width: 14px;
        height: 13px;
        background-size: cover;
      }
    }
    .desc {
      padding-left: 60px;
      /deep/ p {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 20px;
        letter-spacing: 1px;
      }
      /deep/ .tit {
        span {
          text-indent: 12px;
          display: inline-block;
        }
      }
    }
    .bg {
      padding-left: 60px;
      margin-top: 20px;
      .img {
        width: 431px;
        height: 260px;
        background: url("../../assets/assetcenter/withdraw_bg.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .sw {
    margin: 64px 0 50px 0;
  }
  .feeaccount {
    display: flex;
    justify-content: center;
    align-items: center;
    .feeform {
      width: 460px;
      .ivu-form-item {
        /deep/.ivu-form-item-content {
          .ivu-select-selection {
            background: #fff;
            color: #232325;
            font-weight: 500px;
            border-radius: 8px;
          }
          a {
            position: absolute;
            right: 0;
            top: -28px;
          }
          .all {
            position: absolute;
            right: 0;
            top: -28px;
            color: #5e8ffc;
            cursor: pointer;
          }
          .withdraw {
            position: absolute;
            left: 48px;
            top: -28px;
            color: #5e8ffc;
          }
        }
      }
      .ivu-input-wrapper {
        /deep/.ivu-input {
          background: #fff;
          color: #232325;
          font-weight: 500px;
        }
        /deep/.ivu-input-group-append {
          background: #fff;
          border-left: 0;
          color: #232325;
          font-size: 14px;
          font-weight: 500px;
        }
      }
      .withdrawBtn {
        margin-top: 45px;
        display: flex;
        justify-content: center;
        /deep/.ivu-form-item-content {
          .ivu-btn {
            height: 50px;
            width: 360px;
            background: linear-gradient(
              90deg,
              rgba(129, 169, 250, 1) 0%,
              rgba(74, 112, 242, 1) 100%
            );
            border-radius: 23px;
          }
        }
      }
    }
  }
}
</style>
